import type { FsnbWorkCard } from '@shared/api';
import { Muted, Path } from '../styles';

export function SectionsPath({ card }: { card: FsnbWorkCard }) {
  if (card.sections.length > 0) {
    return (
      <Path>
        {card.sections.map((s) => (
          <li key={s.path}>
            <span className="kind">{s.kind ?? 'Раздел'}</span>
            <span>
              {s.code}. {s.name}
            </span>
          </li>
        ))}
      </Path>
    );
  }
  // Редакции, загруженные до раздела «Нормативная база», хранят только коды.
  return (
    <Muted>
      {card.work.section_path
        ? `Коды разделов: ${card.work.section_path.split('/').join(' › ')}`
        : 'Раздел сборника не указан.'}
    </Muted>
  );
}
